import Link from 'next/link'
import React from 'react'
import { FaMapMarkerAlt } from 'react-icons/fa'

export const TrainersNeighborhood = ({localityList}) => {
  return (
    <section className='relative py-14 overflow-hidden bg-slate-950'>
        {/* Ambient glow orbs */}
        <div className="pointer-events-none absolute top-[-10%] right-[-5%] w-87.5 h-87.5 rounded-full bg-orange-500/5 blur-[100px]" />
        <div className="pointer-events-none absolute bottom-[-10%] left-[-5%] w-75 h-75 rounded-full bg-amber-400/4 blur-[80px]" />

        <div className='relative max-w-5xl mx-auto px-4'>
            {/* Header */}
            <div className='text-center mb-8'>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-orange-500/10 text-orange-400 border border-orange-500/20 backdrop-blur-sm mb-4">
                    <FaMapMarkerAlt className="text-[10px]" /> Neighborhoods
                </span>
                <h2 className='text-2xl md:text-3xl font-extrabold text-white tracking-tight mb-3'>
                    Choose Your Neighborhood
                </h2>
                <p className='text-sm md:text-base text-white/40 leading-relaxed max-w-2xl mx-auto'>
                    Select your area to find certified personal trainers available in your neighborhood. From Orchard to Tampines, we have trainers everywhere in Singapore.
                </p>
            </div>

            {/* Glass container */}
            <div className='relative bg-white/4 backdrop-blur-2xl border border-white/10 rounded-3xl p-6 md:p-8 shadow-xl shadow-orange-500/5'>
                {/* Liquid-glass top highlight */}
                <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-linear-to-r from-transparent via-white/20 to-transparent rounded-t-3xl" />

                <h3 className='text-lg font-semibold text-center text-white/70 mb-6'>
                    Choose Your Neighborhood
                </h3>

                <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3'>
                    {[...localityList].filter((locale) => {if(locale != "Singapore") return true}).map((locality, i) =>
                        <Link
                            key={i}
                            href={`/sg/personal-trainer/trainer-list/${encodeURIComponent(locality)}`}
                            prefetch={false}
                            className='group block text-center py-3 px-3 bg-white/4 border border-white/8 rounded-xl text-white/55 hover:bg-orange-500/10 hover:border-orange-400/25 hover:text-orange-400 transition-all duration-300 font-medium text-sm backdrop-blur-sm'
                        >
                            <span className="group-hover:translate-x-0.5 inline-block transition-transform duration-200">
                                {locality}
                            </span>
                        </Link>
                    )}
                </div>

                <div className='text-center mt-6'>
                    <p className='text-xs text-white/30'>
                        Tap on any neighborhood to view available personal trainers in that area
                    </p>
                </div>
            </div>
        </div>
    </section>
  )
}
